<template>
  <v-app>
  </v-app>
</template>

<script>
export default {
  data() {
    // CSidebarNavItemにクリックイベントが無いので遷移させてログアウト処理を実行している
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  created(){
    this.$store.dispatch("auth/logout");
  }
};
</script>

<style module>
.form {
  background-color: #ffffff;
  width: 350px;
  min-width: 300px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px 30px;
}

.error {
  color: #ff1100;
  text-align: center;
}

.logo {
  width: 100%;
  position: relative;
  left: -24px;
  padding: 0;
  margin-bottom: 60px;
}
</style>
